import { render, staticRenderFns } from "./CoursesCompletedSidebar.vue?vue&type=template&id=8afa335a"
import script from "./CoursesCompletedSidebar.vue?vue&type=script&lang=js"
export * from "./CoursesCompletedSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports